import { render } from "./PreviewReport.vue?vue&type=template&id=ffcb194c"
import script from "./PreviewReport.vue?vue&type=script&lang=js"
export * from "./PreviewReport.vue?vue&type=script&lang=js"

import "./PreviewReport.vue?vue&type=style&index=0&id=ffcb194c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__